import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-parameter-popup',
  templateUrl: './parameter-popup.component.html',
  styleUrls: ['./parameter-popup.component.scss']
})
export class ParameterPopupComponent implements OnInit {
  displayedColumns = ['Type', 'Schedule Session', 'Text type', 'Text', 'Branch Id', 'ResD'];
  ParameterForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  showSubmitButton = true;
  ExamBranch = false;
  id: any;
  parameterList: any;
  parameter: any;
  list;
  filteredExamAList: any;
  ExamAList: any[];
  SessionNo: any;
  BranchList: any;
  filteredListBranch: any;
  showVisibleAuto = false;
  ShowVisibleCale = false;
  userPermission: any;
  utp: string;
  parameterCreate=true;
  constructor(public umsService: UmsService, private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute, private spinner: NgxSpinnerService) { }
    dialogRef: MatDialogRef<any>;
    ngOnInit(): void {
      this.submitButton = true;
      this.getParameterData();
      this.list = true;
      this.ParameterForm = this.fb.group({
        Exam: new FormControl(''),
        Type: new FormControl(''),
        ShSn: new FormControl(''),
        TextType: new FormControl(''),
        Text: new FormControl('',Validators.pattern('^[a-zA-Z]*$')),
        BrId: new FormControl(''),
        ResD: new FormControl('')
      });
      if (this.data.key == "Edit") {
        this.prepopulation(this.data.selected);
      }
      if (JSON.parse(sessionStorage.getItem("session")) == null) {
        this.fetchSecretData();
      }
      else if (JSON.parse(sessionStorage.getItem("session")) != null) {
        let sessionData = JSON.parse(sessionStorage.getItem("session"));
        this.SessionNo = sessionData.SnNo;
        this.fetchSupExamRecord(this.SessionNo);
      }

    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      this.userPermission.forEach(element => {
      if(element.PageName == 'Faculty' && element.PCreate == false)
      {
          this.parameterCreate = false;  
      }
    });
  }
    }
  
    prepopulation(id) {
      this.submitButton =false;
      let Exam ;
      if (id.PrmType == "SH") {
        this.showVisibleAuto = false;
        this.ShowVisibleCale = true;
        Exam = id.PrmShSn
      } else {
        this.showVisibleAuto = true;
        this.ShowVisibleCale = false;
        Exam ='C'
        
      }
      // this.spinner.show();
      this.ParameterForm = this.fb.group({
        Exam: new FormControl(Exam),
        Type: new FormControl(''),
        ShSn: new FormControl(''),
        TextType: new FormControl(id.PrmTextType),
        Text: new FormControl(id.PrmText),
        BrId: new FormControl(id.PrmBrId),
        ResD: new FormControl(id.PrmResD)
    });
      // const payload = {};
      // payload['Type'] = id.PrmType;
      // payload['ShSn'] = this.SessionNo;
      // payload['BrId'] = '';
      // this.umsService.getParameter(payload).subscribe((res) => {
      //   this.spinner.hide();
      //   const data = res.data[0];
      //   if (res.status){
           
      //    }else{
           
      //    }
      //  });
    }
    fetchSecretData() {
      this.umsService.getSecretData().subscribe((res) => {
        this.SessionNo = res.projectPharam['SnNo']
        this.fetchSupExamRecord(this.SessionNo);
      }
      );
    }
    getParameterData() {
      const payload = {};
      payload['Type'] = '';
      payload['ShSn'] = this.SessionNo;
      payload['BrId'] = '';
      this.umsService.getParameter(payload).subscribe(res => {
        this.parameterList = res.data;
      });
    }
  
    submit() {
      if (this.ParameterForm.invalid) {
        this.ParameterForm.get('Type').markAsTouched();
        this.ParameterForm.get('ShSn').markAsTouched();
        this.ParameterForm.get('TextType').markAsTouched();
        this.ParameterForm.get('Text').markAsTouched();
        this.ParameterForm.get('BrId').markAsTouched();
        this.ParameterForm.get('ResD').markAsTouched();
        return;
      } else {
        this.saveParameter();
      }
    }
  
    saveParameter() {
      let ShSnValue;
      let ShSnType;
      this.submitpayload = this.ParameterForm.value;
      if(this.ParameterForm.value.Exam == 'C')
      {
        ShSnValue = this.SessionNo;
        ShSnType = 'SN'
      }
      else{
        ShSnValue = this.ParameterForm.value.Exam;
        ShSnType = 'SH'
      }
      this.submitpayload['Type'] = ShSnType;
      this.submitpayload['ShSn'] = ShSnValue;
      this.submitpayload['TextType'] = this.ParameterForm.value.TextType;
      this.submitpayload['Text'] =  this.ParameterForm.value.Text;
      this.submitpayload['BrId'] =this.ParameterForm.value.BrId;
      this.submitpayload['ResD'] = this.ParameterForm.value.ResD;
      this.umsService.addParameter(this.submitpayload).subscribe(res => {
        if (res.status) {
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit()
        } else {
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.ngOnInit()
        }
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      });
    }
  
  
    editdata(e, k) {
      if (e === 'true') {
        this.list = false;
        // this.getParameterData();
        // this.parameter = k;
        // this.prepopulation(this.parameter);
      } else {
        this.list = true;
      }
    }
  
    redirect(to): void {
      this.router.navigate([to]);
    }
  
  
  
    fetchSupExamRecord(SnNo) {
      this.spinner.show();
      let payload = {};
      payload['LoginId'] = sessionStorage.getItem('userId');
      payload['ShSnNo'] = SnNo;
      this.umsService.getSupExamRecord(payload).subscribe((res) => {
       
        if (res.status) {
          this.spinner.hide();
          this.ExamAList = res.data;
          this.addStaticOption();
          this.filteredExamAList = this.ExamAList.slice();
        } else {
          this.spinner.hide();
          this.ExamAList = [];
          this.filteredExamAList = this.ExamAList.slice();
        }
      },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.ExamAList = [];
          this.filteredExamAList = this.ExamAList.slice();
        }
      );
    }
  
  
    getExamData(item) {
      
      ;

      let payload = {};
      payload['EmId'] = item.ShEmId;
      this.umsService.getExam(payload).subscribe((res) => {
        if (res.data[0].EmStreams == 'Y') {
          this.ExamBranch = true;
        } else {
          this.ExamBranch = false;
        }
        this.fetchBranch(item)
      }, (ERROR: HttpErrorResponse) => {
        // this.spinner.hide();
      });
  
      if (item.EmName == "Common") {
        this.showVisibleAuto = true;
        this.ShowVisibleCale = false;
      } else {
        this.showVisibleAuto = false;
        this.ShowVisibleCale = true;
      }


    }
  
    fetchBranch(item) {
      const payload = {};
      payload['EmId'] = item.ShEmId;
      this.umsService.getExamStream(payload).subscribe(res => {
        if (res.status) {
          this.BranchList = res.data;
          this.filteredListBranch = this.BranchList.slice();
        }
      });
    }
  
  
    // this for Common Option need to add in dropdown
    addStaticOption() {
      const staticOption = {
        ShId: 'C',
        EmCode: 'C',
        EmName: 'Common'
      };
      if (!this.ExamAList.some(item => item.ShId === staticOption.ShId)) {
        this.ExamAList.push(staticOption);
      }
    }
  
   
}
